<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div>
  <div class="row">
    <div class="col-md-12">
      <app-breadcrumb></app-breadcrumb>
    </div>
  </div>
  <div class="row">
    <div class="d-flex gap-3 col-md-12 justify-content-end">
      <button mat-stroked-button class="cancelButton" (click)="back()">
        Cancel
      </button>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="saveTraining()"
        (keydown.enter)="saveTraining()" *ngIf="visibleAddTrainingButton && saveButtonForTraining">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="saveTraining()"
        (keydown.enter)="saveTraining()" *ngIf="visibleEditTrainingButton && saveButtonForTraining">
        <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Update</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="assignTraining()"
        (keydown.enter)="assignTraining()"
        *ngIf="visibleEditTrainingButton && trainingData.status == 'Published' && message.isTrainingGroupAdministrator">
        <i class="fa fa-tasks" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Assign Training</span>
      </div>
      <div class=" float-right d-flex gap-2 action-buttons-container">
        <div *ngFor="let button of buttonLabels"
          class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="dynamicButtonClick(button)" (keydown.enter)="dynamicButtonClick(button)">
          <span class="reload_text text-white">{{button}}</span>
        </div>
        <div class="addIconContiner d-flex gap-1 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        </div>
        <div class="addIconContiner d-flex gap-1 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser && selectedTabIndex == 0" (click)="auditTrail()"
          (keydown.enter)="auditTrail()">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
        </div>
      </div>
      <div *ngIf="message.isTopicAdministrator">
        <div class="d-flex align-items-center justify-content-center communication_cta communication-icon pointer"
          matTooltip="Communication">
          <img src="../../../assets/img/cr_module/communication.svg" width="14px" height="14px" alt=""
            (click)="openTopicPopup()" (keydown.enter)="openTopicPopup()" />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="instructions !=''">
      <p style="text-align: right;"><i>{{instructions}}</i></p>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tab">
          <mat-tab-group selectedIndex="0" mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4"
            style="height:600px;" animationDuration="0ms" (selectedTabChange)="onTabChanged($event);"
            [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="Training Details">
              <ng-template mat-tab-label>
                <span><i class='fa-solid fa-book-open' style="font-size: 18px;"
                    aria-hidden="true"></i></span>&nbsp;<span>Training Details</span>
              </ng-template>
              <div class="table-container">
                <div id="form-field-container" class="row">
                  <div class="col-md-2">
                    <div *ngIf="displaytrainingImage">

                      <img class="trainingImage" src="data:image/jpg;base64,{{displaytrainingImage}}" alt="training">
                    </div>
                    <div *ngIf="!displaytrainingImage">
                      <img class="trainingImage" src="../../assets/img/missing.jpg" alt="training">
                    </div>
                    <div class="form-group" *ngIf="saveButtonForTraining">
                      <label for="type">
                        <b>
                          <span *ngIf="trainingData.trainingImage">Update</span>
                          <span *ngIf="!trainingData.trainingImage">Add</span>
                          Training Image:
                        </b>
                      </label>
                      <div>
                        <span *ngIf="!clearedTrainingImage && trainingImage">
                          <p style="display: inline-block;">
                            {{trainingData.trainingName}}.{{trainingData.trainingImageExtn}}</p><i class="fa fa-close"
                            (click)="removeImage()" (keydown.enter)="removeImage()"
                            style="color: red;margin-left: 8px;font-size: 18px;"></i>
                        </span>
                        <div *ngIf="clearedTrainingImage || !trainingImage" class="button-continer">
                          <button class="uploadButton" (click)="openFileDialog()" style="border-radius: 5px;">
                            Choose File</button>
                          <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)" />
                        </div>
                      </div>
                    </div>
                    <div class="form-group text-center" *ngIf="!saveButtonForTraining && trainingImage">
                      <label for="type">
                        <b>
                          Training Image:
                        </b>
                      </label>
                      <div>
                        <span>
                          <p style="display: inline-block;">
                            {{trainingData.trainingName}}.{{trainingData.trainingImageExtn}}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-10">
                    <div class="row field-styles">
                      <div class="col-md-12">
                        <div><label id="training-name-validation" for="trainingName ">Training Name<span
                              class="mandatory-symbol">*</span></label>
                        </div>
                        <input id="trainingName" class="input-filed-continers" type="text"
                          [(ngModel)]="trainingData.trainingName"
                          (ngModelChange)="onNgModelChange(trainingData.trainingName, 'training-name-validation')"
                          [disabled]="!saveButtonForTraining" autocomplete="off">
                      </div>
                    </div>
                    <div class="row field-styles">
                      <div class="col-md-4">
                        <div><label id="training-code-validation" for="trainingCode">Training Code<span
                              class="mandatory-symbol">*</span></label>
                        </div>
                        <input id="trainingCode" class="input-filed-continers" type="text"
                          [(ngModel)]="trainingData.trainingCode"
                          (ngModelChange)="onNgModelChange(trainingData.trainingCode, 'training-code-validation')"
                          [disabled]="!saveButtonForTraining" autocomplete="off">
                      </div>

                      <div class="col-md-4" *ngIf="trainingData.version !=null">
                        <div><label for="version">Version</label></div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="trainingData.version" disabled>
                      </div>
                      <div class="col-md-4" *ngIf="trainingData.status !=null">
                        <div><label for="status">Status</label></div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="trainingData.status" disabled>
                      </div>
                    </div>
                    <div class="row field-styles">
                      <div class="col-md-12">
                        <div style="margin-bottom: 1%;">
                          <st-editor [(ngModel)]="trainingData.description" [config]="config" [spellcheck]="true"
                            [disabled]="!saveButtonForTraining"></st-editor>
                        </div>
                      </div>
                    </div>
                    <div class="row field-styles">
                      <div class="col-md-4">
                        <div>
                          <label for="email" id="category-validation">Category</label>
                          <span class="mandatory-symbol">*</span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedCategory"
                          [ngClass]="{'odd-item-mat-select': oddCategory == selectedCategory}"
                          [disabled]="!saveButtonForTraining" (closed)="categorySearchText=''"
                          (click)="focusSearch('focus-category-search')"
                          (keydown.enter)="focusSearch('focus-category-search')">
                          <input type="search" id="focus-category-search" class="dropdownsearchstyle"
                            [(ngModel)]="categorySearchText" matInput placeholder="search">
                          <mat-option [value]="null" class="unselectStyle"
                            (onSelectionChange)="onCategorySelect($event,null);">Un-select</mat-option>
                          <mat-option *ngFor="let item of categoryDropdown | assessmentSearch : categorySearchText"
                            (onSelectionChange)="onCategorySelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                          </mat-option>
                        </mat-select>
                      </div>
                      <div class="col-md-4">
                        <div><label id="type-validation" for="trainingType">Training Type<span
                              class="mandatory-symbol">*</span></label>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedTrainingType"
                          [ngClass]="{'odd-item-mat-select': oddType == selectedTrainingType}"
                          [disabled]="!saveButtonForTraining" (closed)="typeSearchText=''"
                          (click)="focusSearch('focus-type-search')" (keydown.enter)="focusSearch('focus-type-search')">
                          <input type="search" id="focus-type-search" class="dropdownsearchstyle"
                            [(ngModel)]="typeSearchText" matInput placeholder="search">
                          <mat-option [value]="null" class="unselectStyle"
                            (onSelectionChange)="onTrainingTypeSelect($event,null);">Un-select</mat-option>
                          <mat-option *ngFor="let item of trainingTypeDropdown | assessmentSearch : typeSearchText"
                            (onSelectionChange)="onTrainingTypeSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                          </mat-option>
                        </mat-select>
                      </div>
                      <div class="col-md-4">
                        <div><label for="totalDuration">Total Duration</label></div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="trainingData.totalDuration"
                          (keypress)="omit_special_char($event)" [disabled]="!saveButtonForTraining">
                      </div>

                    </div>
                    <div class="row field-styles">
                      <div class="col-md-4">
                        <div><label id="language-validation" for="language">Language<span
                              class="mandatory-symbol">*</span></label></div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedLanguage"
                          [ngClass]="{'odd-item-mat-select': oddLanguage == selectedLanguage}"
                          [disabled]="!saveButtonForTraining" (closed)="languageSearchText=''"
                          (click)="focusSearch('focus-language-search')"
                          (keydown.enter)="focusSearch('focus-language-search')">
                          <input type="search" id="focus-language-search" class="dropdownsearchstyle"
                            [(ngModel)]="languageSearchText" matInput placeholder="search">
                          <mat-option [value]="null" class="unselectStyle"
                            (onSelectionChange)="onLanguageSelect($event,null);">Un-select</mat-option>
                          <mat-option *ngFor="let item of languageDropdown | assessmentSearch : languageSearchText"
                            (onSelectionChange)="onLanguageSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                          </mat-option>
                        </mat-select>
                      </div>
                      <div class="col-md-4">
                        <div class="row">
                          <div class="col-md-6">
                            <div><label for="trainingType">Expiry Date/Expiry Days?</label>
                              <mat-slide-toggle color="primary" [(ngModel)]="expDateOrDay"
                                (change)="isExpiryDateChecked($event.checked)" [disabled]="!saveButtonForTraining">
                                <span class="active-inActive-container" *ngIf="expDateOrDay==true"
                                  [ngStyle]="expDateOrDay==true?{'color':'green'} : {'color': ''}"></span>
                                <span *ngIf="expDateOrDay==false"
                                  [ngStyle]="expDateOrDay==false?{'color':'red'} : {'color': ''}"></span>
                              </mat-slide-toggle>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div><label *ngIf="isShowDateField" for="trainingType">Expiry Date</label>
                              <label *ngIf="!isShowDateField" for="trainingType">Expiry Day(s)</label>
                              <input *ngIf="isShowDateField" type="text" class="form-control data-picker-continer"
                                bsDatepicker [bsConfig]="datePickerConfiguration"
                                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="trainingData.expiryDate"
                                [minDate]="minDate">
                              <input *ngIf="!isShowDateField" type="number" min="0" class="input-filed-continers"
                                [(ngModel)]="trainingData.expiryInDays" (keypress)="omit_special_char($event)">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4" style="width: 14%;">
                        <div><label for="email">Self Assignable?</label></div>
                        <mat-slide-toggle color="primary" [(ngModel)]="trainingData.selfAssignable1"
                          (change)="isSelfAssignedFunction($event.checked)" [disabled]="!saveButtonForTraining">
                          <span class="active-inActive-container" *ngIf="trainingData.selfAssignable1==true"
                            [ngStyle]="trainingData.selfAssignable1==true?{'color':'green'} : {'color': ''}"></span>
                          <span *ngIf="trainingData.selfAssignable1==false"
                            [ngStyle]="trainingData.selfAssignable1==false?{'color':'red'} : {'color': ''}"></span>
                        </mat-slide-toggle>
                      </div>

                      <div class="col-md-4">
                        <div><label for="meetingUrl">Meeting URL</label></div>
                        <input id="meetingUrl" class="input-filed-continers" type="text"
                          [(ngModel)]="trainingData.meetingUrl" (ngModelChange)="onMeetingUrlChange()"
                          [disabled]="!saveButtonForTraining" autocomplete="off"
                          placeholder="https://meet.google.com/... or teams/zoom link"
                          [style.border]="isMeetingUrlInvalid ? '1px solid red' : ''">

                        <span *ngIf="isMeetingUrlInvalid"
                          style="color: red; font-size: 11px; display: block; margin-top: 4px;">
                          Only valid Google Meet, MS Teams, or Zoom HTTPS URLs are allowed.
                        </span>
                      </div>
                    </div>
                    <div class="row field-styles">
                      <div class="col-md-6"
                        *ngIf="(visibleEditTrainingButton && saveButtonForTraining) || visibleReasonForTrainingUpdateField">
                        <div><label for="description">Reason for Update<span class="mandatory-symbol">*</span></label>
                        </div>
                        <textarea [rows]="6" id="reasonForUpdate" type="text" class="textarea-filed-continers" rows="4"
                          cols="50" [(ngModel)]="trainingData.updateReason"></textarea>
                        <span id="reasonForUpdate-required-msg"
                          *ngIf="(trainingData.updateReason == null || trainingData.updateReason.trim() === '') && onClickedSaveButton"
                          style="display: block;">
                          Please enter the reason for update
                        </span>
                      </div>
                      <div class="col-md-4"
                        *ngIf="trainingData.expiryDate != null  || trainingData.expiryInDays != null">
                        <div><label for="totalDuration">Intimate Expiry Before (In days)</label></div>
                        <input class="input-filed-continers" type="number"
                          [(ngModel)]="trainingData.intimateExpiryBeforeInDays" min="0"
                          (keypress)="omit_special_char($event)" [disabled]="!saveButtonForTraining"
                          (ngModelChange)="checkWarning()">
                      </div>

                    </div>
                    <br><br>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Contents" *ngIf="trainingData.trainingId != undefined">
              <ng-template mat-tab-label>
                <span><i class='fa-solid fa-list' style="font-size: 18px;"
                    aria-hidden="true"></i></span>&nbsp;<span>Contents</span>
              </ng-template>
              <app-training-content [trainingData]="trainingData"></app-training-content>
            </mat-tab>
            <mat-tab label="Reviewer/Approver" *ngIf="taskStagesList.length > 0">
              <ng-template mat-tab-label>
                <span><i class='fa-solid fa-file-circle-check' style="font-size: 18px;"
                    aria-hidden="true"></i></span>&nbsp;
                <span>Reviewer/Approver</span>
              </ng-template>
              <app-stage-user [data]="trainingData"></app-stage-user>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
  <ng-template #confirmWithReasonPopup>
    <h2 mat-dialog-title>{{title }}</h2>
    <div style="margin: 15px 15px;">
      <div class="form-continer">
        <div class="row">
          <div class="col-md-12">
            {{warMsg}} Do you want to proceed with {{buttonLabel}}?
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-12">
            <div><label for="reason"> Reason</label><span class="mandatory-symbol">*</span></div>
            <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"></textarea>
            <div id="reason-val-icon" class="field-icon-container"></div>
            <span id="reason-required-msg">Please enter reason</span>
          </div>
        </div>
        <br>
      </div>
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
          {{buttonLabel}}
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #confirmPopup>
    <h2 mat-dialog-title>{{title }}</h2>
    <div style="margin: 15px 15px;">
      <div class="form-continer">
        <div class="row">
          <div class="col-md-12">
            {{warMsg}} Do you want to proceed with {{buttonLabel}}?
          </div>
        </div>
        <br>
      </div>
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="confirmOkFunc()">
          {{buttonLabel}}
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #confirmWithDataPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelConfirmWithDataFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{buttonLabel}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="padding: 2%;">
      <div class="row">
        <div class="col-md-6" style="border-right: 1px solid black;">
          <div><label style="margin-left: 20%;font-weight: 600;" for="status">Action</label><span
              class="mandatory-symbol">*</span></div>
          <mat-radio-group id="status" class="tp-radio-group" [(ngModel)]="selectedStatus"
            style="display: flex;flex-direction: column;">
            <mat-radio-button class="tp-radio-button" *ngFor="let status of statusList" [value]="status.codelistCode"
              (change)="onStatusSelect(status.codelistCode)">
              {{status.codelistName}}
            </mat-radio-button>
          </mat-radio-group>
          <span style="margin-left: 25%;" id="status-required-msg">Please select status</span>
        </div>
        <div class="col-md-6" *ngIf="isEsignRequired" style="margin-top: 2%;">
          <div class="row" *ngIf="isEsignRequired">
            <div><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
            </div>
            <div> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
                [(ngModel)]="displayUserName" disabled>
            </div>
          </div>
          <div class="row" *ngIf="(isEsignRequired && !isAdEnabled)">
            <div><label for="pass ">Password</label><span class="mandatory-symbol">*</span></div>
            <div> <input id="pass" style="height: 80% !important;" class="input-filed-continers"
                [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
              <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
                <i
                  [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
              </span>
            </div>
            <span style="margin-left: 25%;" id="pass-required-msg">Please enter password</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div><label for="comment">Comments</label></div>
        <div> <textarea rows="4" id="comment" class="textarea-filed-continers" type="text"
            [(ngModel)]="comments"></textarea>
        </div>
      </div>

      <div class="row" *ngIf="isShowRejectReason" style="width: 60%;margin-bottom: 1%;">
        <div><label for="rejectReason">Reject Reason</label><span class="mandatory-symbol">*</span></div>
        <div>
          <mat-select id="rejectReason" t matInput placeholder="Select" [(ngModel)]="selectedRejectReason"
            (closed)="rejectReasonSearchText=''" (click)="focusSearch('focus-reject-reason-search')"
            (keydown.enter)="focusSearch('focus-reject-reason-search')">
            <input type="search" id="focus-reject-reason-search" class="dropdownsearchstyle"
              [(ngModel)]="rejectReasonSearchText" matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onRejectReasonSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of rejectReasonDropdown | assessmentSearch : rejectReasonSearchText"
              (onSelectionChange)="onRejectReasonSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>

        </div>
        <span style="margin-left: 25%;" id="rejectReason-required-msg">Please select reject reason</span>
      </div>

      <div class="row" *ngIf="isReasonSignReqd" style="width: 60%;margin-bottom: 1%;">
        <div><label for="reasonForSignature">Reason for Signature</label><span class="mandatory-symbol">*</span></div>
        <div>
          <mat-select id="reasonForSignature" t matInput placeholder="Select" [(ngModel)]="selectedReason"
            (closed)="reasonSearchText=''" (click)="focusSearch('focus-reason-search')"
            (keydown.enter)="focusSearch('focus-reason-search')">
            <input type="search" id="focus-reason-search" class="dropdownsearchstyle" [(ngModel)]="reasonSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReasonSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reasonDropdown | assessmentSearch : reasonSearchText"
              (onSelectionChange)="onReasonSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <span style="margin-left: 25%;" id="reasonForSignature-required-msg">Please select reason for
          signature</span>
      </div>

      <div class="row">
        <div><label for="comment">Document</label></div>
        <div>
          <span *ngIf="!clearedOperationDoc && evidenceFile">
            <p style="display: inline-block;">{{ buttonOperationFile?.name }}</p><i class="fa fa-close"
              (click)="removeOperationDoc()" (keydown.enter)="removeOperationDoc()"
              style="color: red;margin-left: 8px;font-size: 18px;"></i>
          </span>
          <input *ngIf="clearedOperationDoc || !evidenceFile" type="file" class="file-input"
            (change)="onConfirmFileSelected($event)" #fileUpload>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmWithDataFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmWithDataFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>

  <ng-template #topicPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" mat-button (click)="canceltopicPopup()"><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Trainigs Topics </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <app-oneqms-topics [topicData]=""></app-oneqms-topics>
  </ng-template>
  <ng-template #infoPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="okInfo()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Warning</label>
      <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div style="margin: 15px 15px">
      <div class="row">
        <div class="col-md-12">
          {{ warningMsg }}
        </div>
      </div>
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="okInfo()">
          OK
        </button>
      </div>
    </div>
  </ng-template>
  <app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
  <app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
  <app-assign-training #training *ngIf="showAssignTraining"
    (popupClosed)="onTrainingPopupClosed()"></app-assign-training>